webpackJsonp([35783957827783],{

/***/ 2542:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/action-blueprints-mobile.dabe141f.png";

/***/ }),

/***/ 2543:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/action-blueprints.0bcd8f3a.png";

/***/ }),

/***/ 2544:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/decorator-lazy-loading.b24ef893.png";

/***/ }),

/***/ 2545:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/react-logo.692adb35.png";

/***/ }),

/***/ 2546:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/react-router-logo.90bf4f3c.png";

/***/ }),

/***/ 2547:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/redux-logo.80a9c063.png";

/***/ }),

/***/ 2548:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/webpack-logo.2e33bbec.png";

/***/ }),

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  var icon = props.icon,
	      imageSrc = props.imageSrc,
	      imageHeight = props.imageHeight,
	      imageMarginBottom = props.imageMarginBottom,
	      title = props.title,
	      description = props.description,
	      url = props.url;
	
	
	  return _react2.default.createElement(
	    'li',
	    { className: 'm-b-lg' },
	    _react2.default.createElement(
	      'div',
	      { className: 'featured-list-icon text-primary' },
	      icon ? _react2.default.createElement('span', { className: 'icon icon-' + icon }) : _react2.default.createElement('img', { src: imageSrc, style: { height: imageHeight, marginBottom: imageMarginBottom } })
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'featured-list-icon-text m-b-0' },
	      _react2.default.createElement(
	        'strong',
	        null,
	        title
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'featured-list-icon-text' },
	      description,
	      ' ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: url, className: 'text-primary' },
	        'Learn more'
	      ),
	      '.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 284:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Feature = __webpack_require__(202);
	
	var _Feature2 = _interopRequireDefault(_Feature);
	
	var _reduxLogo = __webpack_require__(2547);
	
	var _reduxLogo2 = _interopRequireDefault(_reduxLogo);
	
	var _reactLogo = __webpack_require__(2545);
	
	var _reactLogo2 = _interopRequireDefault(_reactLogo);
	
	var _reactRouterLogo = __webpack_require__(2546);
	
	var _reactRouterLogo2 = _interopRequireDefault(_reactRouterLogo);
	
	var _webpackLogo = __webpack_require__(2548);
	
	var _webpackLogo2 = _interopRequireDefault(_webpackLogo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'block block-secondary', style: { paddingBottom: '50px', paddingTop: '50px' } },
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row', style: { paddingTop: '32px', paddingBottom: '24px' } },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-8 col-sm-offset-2 text-center' },
	          _react2.default.createElement(
	            'h6',
	            { className: 'text-muted text-uppercase' },
	            'Heavily reduced learning curve'
	          ),
	          _react2.default.createElement(
	            'h3',
	            { className: 'm-t-0' },
	            'Preconfigured with ',
	            _react2.default.createElement(
	              'strong',
	              { style: { textDecoration: 'underline' } },
	              'sensible defaults'
	            ),
	            '.'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'lead m-b-md' },
	            'For each of the libraries Lore is built on, we looked at what were the most common tasks and challenges in working with them, and then integrated functionality into Lore to improve that experience. Behavior for all libraries can also be easily tailored through simple config files.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-4' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'featured-list featured-list-bordered' },
	            _react2.default.createElement(_Feature2.default, {
	              icon: 'folder',
	              title: 'Project Template',
	              description: 'Easily create new projects using Lore\'s CLI, preconfigured with everything you need to get started building React applications.',
	              url: '/cli/lore-generate-new/'
	            }),
	            _react2.default.createElement(_Feature2.default, {
	              imageSrc: _reduxLogo2.default,
	              imageHeight: '60px',
	              imageMarginBottom: '20px',
	              title: 'Redux',
	              description: 'Lore uses conventions to provide overridable blueprints for actions and reducers, along with a decorator that allows components to declare the data they need.',
	              url: '/features/core/redux/'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-4' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'featured-list featured-list-bordered' },
	            _react2.default.createElement(_Feature2.default, {
	              imageSrc: _reactLogo2.default,
	              imageHeight: '64px',
	              imageMarginBottom: '14px',
	              title: 'React',
	              description: 'Lore automatically mounts the application to the DOM, and subscribes the app to the store so components automatically update when data changes.',
	              url: '/features/core/react/'
	            }),
	            _react2.default.createElement(_Feature2.default, {
	              imageSrc: _reactRouterLogo2.default,
	              imageHeight: '30px',
	              imageMarginBottom: '16px',
	              title: 'Routing',
	              description: 'React-router preintegrated into project, easily configured, and routes are clearly exposed at the root of the project.',
	              url: '/features/core/react-router/'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-4' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'featured-list featured-list-bordered' },
	            _react2.default.createElement(_Feature2.default, {
	              imageSrc: _webpackLogo2.default,
	              imageHeight: '64px',
	              imageMarginBottom: '14px',
	              title: 'Webpack',
	              description: 'Common loaders pre-installed in config with a modular setup that allows you to override the Webpack config on a per-environment basis.',
	              url: '/features/core/webpack/'
	            }),
	            _react2.default.createElement(_Feature2.default, {
	              icon: 'cloud',
	              title: 'Publishing',
	              description: _react2.default.createElement(
	                'span',
	                null,
	                'Provides a built-in (but easily deleted) script for publishing to ',
	                _react2.default.createElement(
	                  'a',
	                  { href: 'https://zeit.co/now' },
	                  'Now'
	                ),
	                ', an excellent static hosting provider that provides free SSL certs and enables zero-downtime deploys.'
	              ),
	              url: '/publishing/'
	            })
	          )
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 285:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Feature = __webpack_require__(202);
	
	var _Feature2 = _interopRequireDefault(_Feature);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'block block-bordered-lg', style: { paddingTop: '50px' } },
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row', style: { paddingTop: '32px', paddingBottom: '64px' } },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-8 col-sm-offset-2 text-center' },
	          _react2.default.createElement('span', { className: 'icon icon-bar-graph feature-divider' }),
	          _react2.default.createElement(
	            'h6',
	            { className: 'text-muted text-uppercase' },
	            'Focus on adding value without constraint'
	          ),
	          _react2.default.createElement(
	            'h3',
	            { className: 'm-t-0' },
	            'Thoughtfully designed to support ',
	            _react2.default.createElement(
	              'strong',
	              { style: { textDecoration: 'underline' } },
	              'features you\'ll need'
	            ),
	            'as you\'re app grows.'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'lead' },
	            'Lore is serious about building scalable apps. The architectural patterns in the framework are taken from years of building diverse applications, and designed to solve not just the needs you have today, but the ones you\'ll have tomorrow as well.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-4' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'featured-list' },
	            _react2.default.createElement(_Feature2.default, {
	              icon: 'database',
	              title: 'Data Structure',
	              description: 'Enables data-driven components by supplying components with both data and context.',
	              url: '/features/data-structure/'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-4' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'featured-list' },
	            _react2.default.createElement(_Feature2.default, {
	              icon: 'share',
	              title: 'AJAX Abstraction',
	              description: 'Layered communication tier able to communicate with multiple API servers and capable of adapting to changes in data contracts.',
	              url: '/features/ajax-abstraction/'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-4' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'featured-list' },
	            _react2.default.createElement(_Feature2.default, {
	              icon: 'funnel',
	              title: 'Filtering',
	              description: 'Useful for viewing a subset of data that matches a specific criteria.',
	              url: '/features/filtering/'
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-4' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'featured-list' },
	            _react2.default.createElement(_Feature2.default, {
	              icon: 'dots-three-horizontal',
	              title: 'Pagination',
	              description: 'Useful for moving through large datasets, and providing the user with a sliced view of the data.',
	              url: '/features/pagination/'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-4' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'featured-list' },
	            _react2.default.createElement(_Feature2.default, {
	              icon: 'dots-three-vertical',
	              title: 'Infinite Scrolling',
	              description: 'Mobile friendly style of pagination that aggregates fetched data into a single scrollable list.',
	              url: '/features/infinite-scrolling/'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-4' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'featured-list' },
	            _react2.default.createElement(_Feature2.default, {
	              icon: 'publish',
	              title: 'WebSockets (beta)',
	              description: 'Add support for real-time updates through simple configuration, and make a big improvement to the user experience of any team-based application.',
	              url: '/features/websockets/'
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-4' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'featured-list' },
	            _react2.default.createElement(_Feature2.default, {
	              icon: 'image',
	              title: 'Visual Cues',
	              description: 'Easily discover and communicate when data is being updated, fetched or contains an error.',
	              url: '/features/visual-cues/'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-4' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'featured-list' },
	            _react2.default.createElement(_Feature2.default, {
	              icon: 'flow-branch',
	              title: 'Optimistic Updates',
	              description: 'Makes your application feel snappy and responsive by assuming server calls will be successful.',
	              url: '/features/optimistic-updates/'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-4' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'featured-list' },
	            _react2.default.createElement(_Feature2.default, {
	              icon: 'message',
	              title: 'Dialogs',
	              description: 'Helpful utilities to automatically mount, configure and display dialogs.',
	              url: '/features/dialogs/'
	            })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-4' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'featured-list' },
	            _react2.default.createElement(_Feature2.default, {
	              icon: 'chat',
	              title: 'Wizards',
	              description: 'Easily discover when the server confirms data creation before moving onto the next step.',
	              url: '/features/wizards/'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-4' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'featured-list' },
	            _react2.default.createElement(_Feature2.default, {
	              icon: 'new',
	              title: 'Error Handling',
	              description: 'Server errors are passed to components and clearly communicated.',
	              url: '/features/error-handling/'
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-4' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'featured-list' },
	            _react2.default.createElement(_Feature2.default, {
	              icon: 'help-with-circle',
	              title: '404 Pages',
	              description: 'Discover and communicate when resources can\'t be found.',
	              url: '/features/404-pages/'
	            })
	          )
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 286:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    "div",
	    { className: "block block-inverse block-secondary app-code-block" },
	    _react2.default.createElement(
	      "div",
	      { className: "container" },
	      _react2.default.createElement(
	        "div",
	        { className: "row app-align-center" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm-6" },
	          _react2.default.createElement(
	            "h6",
	            { className: "text-muted text-uppercase" },
	            "Project template for the win"
	          ),
	          _react2.default.createElement(
	            "h3",
	            { className: "m-t-0" },
	            "Getting started is ",
	            _react2.default.createElement(
	              "strong",
	              { style: { textDecoration: 'underline' } },
	              "super easy"
	            ),
	            "."
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "lead m-b-md text-muted" },
	            "Just install the CLI and create your project. Everything you need is already included, and the project comes preconfigured with supporting for building, routing and publishing your project."
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "col-sm-6" },
	          _react2.default.createElement(
	            "pre",
	            { className: "app-code", style: { padding: '10px 8px 10px 12px', width: 'auto', whiteSpace: 'pre-line' } },
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "span",
	                null,
	                "$ npm install -g"
	              ),
	              " lore-cli"
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "span",
	                null,
	                "$ "
	              ),
	              " lore new my-app"
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "span",
	                null,
	                "$ "
	              ),
	              " cd my-app"
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "span",
	                null,
	                "$ "
	              ),
	              " npm install"
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "span",
	                null,
	                "$ "
	              ),
	              " npm start"
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "span",
	                null,
	                "$ "
	              ),
	              " ..."
	            ),
	            _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "span",
	                null,
	                "$ "
	              ),
	              " Listening at localhost:3000."
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 287:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Video = __webpack_require__(15);
	
	var _Video2 = _interopRequireDefault(_Video);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'block block-inverse app-header', style: { paddingBottom: '64px' } },
	    _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-12 text-center' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'block-title m-b-sm' },
	              'Build apps worthy of legend'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'lead m-b-md text-muted' },
	              'Convention-driven framework for React.',
	              _react2.default.createElement('br', null),
	              'Built on ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Webpack'
	              ),
	              ', ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'Redux'
	              ),
	              ' and ',
	              _react2.default.createElement(
	                'strong',
	                null,
	                'React Router'
	              ),
	              '.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row', style: { paddingTop: '40px', paddingBottom: '40px' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-12 text-center' },
	            _react2.default.createElement(_Video2.default, { videoId: 'u3cK4fz1GNg' })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'row signup-form-header', style: { paddingTop: '64px' } },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md-12 text-center' },
	            _react2.default.createElement(
	              'p',
	              { style: { color: 'rgba(255, 255, 255, .7)', marginBottom: '15px' } },
	              'Would you like to be notified as new features and docs are released? Sign up!'
	            ),
	            _react2.default.createElement(
	              'h4',
	              { className: 'thank-you-message', style: { display: 'none' } },
	              'Thanks! We\'ll email you when there are noteworthy updates to Lore.'
	            ),
	            _react2.default.createElement(
	              'form',
	              { className: 'form-inline' },
	              _react2.default.createElement(
	                'div',
	                { className: 'form-group' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'input-group' },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'input-group-addon' },
	                    _react2.default.createElement('span', { className: 'icon icon-mail' })
	                  ),
	                  _react2.default.createElement('input', { type: 'email', className: 'form-control', placeholder: 'Email Address' })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'form-group', style: { paddingLeft: '4px' } },
	                _react2.default.createElement(
	                  'button',
	                  { type: 'submit', className: 'form-control btn btn-primary' },
	                  'Notify me'
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 288:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    "div",
	    { className: "block block-inverse app-ribbon p-y-lg" },
	    _react2.default.createElement(
	      "div",
	      { className: "container text-center" },
	      _react2.default.createElement(
	        "div",
	        { className: "row signup-form-ribbon" },
	        _react2.default.createElement(
	          "div",
	          { className: "col-md-12 text-center" },
	          _react2.default.createElement(
	            "p",
	            { className: "lead" },
	            "Would you like to be notified as new features and docs are released?"
	          ),
	          _react2.default.createElement(
	            "h4",
	            { className: "thank-you-message", style: { display: 'none' } },
	            "Thanks! We'll email you when there are noteworthy updates to Lore."
	          ),
	          _react2.default.createElement(
	            "form",
	            { className: "form-inline" },
	            _react2.default.createElement(
	              "div",
	              { className: "form-group" },
	              _react2.default.createElement(
	                "div",
	                { className: "input-group" },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group-addon" },
	                  _react2.default.createElement("span", { className: "icon icon-mail" })
	                ),
	                _react2.default.createElement("input", { type: "email", className: "form-control", placeholder: "Email Address" })
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "form-group", style: { paddingLeft: '4px' } },
	              _react2.default.createElement(
	                "button",
	                { type: "submit", className: "form-control btn btn-primary" },
	                "Notify me"
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 289:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _actionBlueprintsMobile = __webpack_require__(2542);
	
	var _actionBlueprintsMobile2 = _interopRequireDefault(_actionBlueprintsMobile);
	
	var _actionBlueprints = __webpack_require__(2543);
	
	var _actionBlueprints2 = _interopRequireDefault(_actionBlueprints);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'block block-secondary', style: { paddingBottom: '50px', paddingTop: '50px' } },
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-8 col-sm-offset-2 text-center', style: { paddingBottom: '20px' } },
	          _react2.default.createElement(
	            'h6',
	            { className: 'text-muted text-uppercase' },
	            'Convention-driven Magic'
	          ),
	          _react2.default.createElement(
	            'h3',
	            { className: 'm-t-0' },
	            'Talk to APIs ',
	            _react2.default.createElement(
	              'strong',
	              { style: { textDecoration: 'underline' } },
	              'without'
	            ),
	            ' writing actions or reducers'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'lead m-b-md' },
	            'Lore contains blueprints for common actions and reducers that it configures using the frameworks conventions. By creating a model, Lore provides access to a set of actions and reducers capable of supporting common CRUD operations, which can then be configured or overridden as required.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-10 col-sm-offset-1 col-md-12 col-md-offset-0' },
	          _react2.default.createElement('img', { className: 'hidden-md hidden-lg', src: _actionBlueprintsMobile2.default, style: { width: '100%' } }),
	          _react2.default.createElement('img', { className: 'hidden-xs hidden-sm', src: _actionBlueprints2.default, style: { width: '100%' } })
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 290:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _decoratorLazyLoading = __webpack_require__(2544);
	
	var _decoratorLazyLoading2 = _interopRequireDefault(_decoratorLazyLoading);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'block block-secondary', style: { paddingTop: '0px' } },
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-8 col-sm-offset-2 text-center', style: { paddingBottom: '20px' } },
	          _react2.default.createElement(
	            'h6',
	            { className: 'text-muted text-uppercase' },
	            'Declarative lazy-loading components'
	          ),
	          _react2.default.createElement(
	            'h3',
	            { className: 'm-t-0' },
	            'Then fetch data ',
	            _react2.default.createElement(
	              'strong',
	              { style: { textDecoration: 'underline' } },
	              'just by declaring it.'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'lead m-b-md' },
	            'Lore provides a simple decorator that allows you to declare what data your components need. If this data exists, it will be provided to your component. If it doesn\'t, Lore will ',
	            _react2.default.createElement(
	              'em',
	              null,
	              'automatically'
	            ),
	            ' call the required action and inform your component when the data comes back.'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-10 col-sm-offset-1' },
	          _react2.default.createElement('img', { src: _decoratorLazyLoading2.default, style: { width: '100%' } })
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ }),

/***/ 654:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _hero = __webpack_require__(287);
	
	var _hero2 = _interopRequireDefault(_hero);
	
	var _section = __webpack_require__(289);
	
	var _section2 = _interopRequireDefault(_section);
	
	var _section1b = __webpack_require__(290);
	
	var _section1b2 = _interopRequireDefault(_section1b);
	
	var _gettingStartedEasy = __webpack_require__(286);
	
	var _gettingStartedEasy2 = _interopRequireDefault(_gettingStartedEasy);
	
	var _features = __webpack_require__(284);
	
	var _features2 = _interopRequireDefault(_features);
	
	var _features3 = __webpack_require__(285);
	
	var _features4 = _interopRequireDefault(_features3);
	
	var _ribbon = __webpack_require__(288);
	
	var _ribbon2 = _interopRequireDefault(_ribbon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_hero2.default, null),
	    _react2.default.createElement(_section2.default, null),
	    _react2.default.createElement(_section1b2.default, null),
	    _react2.default.createElement(_gettingStartedEasy2.default, null),
	    _react2.default.createElement(_features2.default, null),
	    _react2.default.createElement(_features4.default, null),
	    _react2.default.createElement(_ribbon2.default, null)
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-408e00954c164970cc23.js